const eventStatuses = {
  CREATED: 'CREATED',
  STARTED: 'STARTED',
  ENDED: 'ENDED',
  CANCELLED: 'CANCELLED'
};

export default eventStatuses;